import { FC, CSSProperties } from 'react';
import { Severity } from '@agilelab/plugin-wb-governance-common';
import { Tooltip, useTheme } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { IconLabelBox } from '../../IconLabelBox';
import { InfoOutlinedIcon } from './Icons';
import { useStyles } from './style';

interface Props {
  severity?: Severity;
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const InformationIcon: FC<Props> = ({
  severity,
  style,
  variant = 'default',
}) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Tooltip
      title={`Failed with severity ${
        severity ?? 'INFO'
      }. This policy is just a warning, and will not block the deployment, but remember to check what errors made it fail`}
    >
      <span>
        {variant === 'reduced' ? (
          <InfoIcon
            className={`${classes.icon}`}
            htmlColor={theme.palette.primary.main}
            style={{ ...style, transform: 'scale(1.2)' }}
          />
        ) : (
          <IconLabelBox
            label="Info"
            backgroundColor={theme.palette.primary.main}
            icon={<InfoOutlinedIcon />}
          />
        )}
      </span>
    </Tooltip>
  );
};
